import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import {
    getSelectedYearMonths,
    monthsIndexes
} from '../../../../Common/Util/getMonthsByYear';
import { useServicesChartsDataContext } from './useServicesChartsDataContext';

const useServicesPerMonthPerYearPercentageChart = () => {
    const { colors, subtitles, chartData, filters } =
        useServicesChartsDataContext();

    const months = getSelectedYearMonths(filters);

    const series = subtitles.map((item, index) => {
        const data = months.map((month) => {
            const found = chartData.selectedYear.find(
                (counter) =>
                    parseInt(counter.mes_competencia, 10) ===
                    monthsIndexes[month]
            );

            return found
                ? (index === 0
                      ? Number(found.percentage_sh_ges)
                      : Number(found.percentage_sp_ges)
                  ).toFixed(2)
                : 0;
        });

        return {
            name: item,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                max: 100
            },
            xaxis: {
                categories: months || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useServicesPerMonthPerYearPercentageChart;
